<template>
  <div>
    <div id="editor-cell"></div>
    <editor v-model="val" :init="initData ? initData : init" @onPaste="paste" />
  </div>
</template>
<script>
import tinymce from 'tinymce/tinymce'
import Cookies from 'js-cookie'
import Editor from '@tinymce/tinymce-vue'
import { uploadFile, uploadFileDirect } from '../../server/common'
import 'tinymce/themes/silver/theme'
tinymce.init({
  selector: '#editor-cell'
})
tinymce.baseURL = process.env.VUE_APP_CDN + 'js'
const defaultToolBar = `formatselect bold italic underline |
  alignleft aligncenter alignright |
  bullist | numlist | outdent | indent | image table link code`
const tinySet = {
  name: 'RichEditor',
  components: {
    Editor
  },
  props: {
    value: {},
    height: {
      type: Number,
      default: 350
    },
    initData: {
      type: [Boolean, Object],
      default: false
    },
    placeholder: {},
    toolbarProp: String
  },
  data() {
    const self = this
    return {
      val: this.value,
      init: {
        language: Cookies.get('language')
          ? Cookies.get('language').replace('-', '_')
          : window.navigator.language.indexOf('en') === 0
          ? 'en'
          : 'zh_CN',
        height: this.height,
        menubar: false,
        branding: false,
        statusbar: false,
        placeholder: this.placeholder,
        // toolbar: false,
        // menubar: 'file edit insert view format table tools help',
        plugins: [
          'advlist autolink lists link image charmap',
          'searchreplace visualblocks code fullscreen',
          'print preview anchor insertdatetime media',
          'paste help wordcount table'
        ],
        paste_data_images: true,
        toolbar: this.toolbarProp || defaultToolBar,
        toolbar_mode: 'wrap',
        images_upload_handler: async function(blobInfo, success, failure, progress) {
          const file = blobInfo.blob()
          if (!file || !file.name) {
            return
          }
          const { data } = await uploadFileDirect(file)
          if (data.code === self.$code) {
            success(data.data.absolutePath)
          } else {
            self.$message.error(data.msg)
          }
        }
      }
    }
  },
  watch: {
    val(val) {
      if (this.value !== val) {
        this.$emit('input', val)
      }
    },
    value: {
      handler(v) {
        if (v !== this.val) {
          this.val = v
        }
      },
      immediate: true
    }
  },
  created() {},
  methods: {
    paste() {
      // console.log(arguments)
    }
  }
}
export default tinySet
</script>
